<template>
  <DynamicLayoutWrapper
    :template="template"
    :questions="questions"
    :document-value="content"
    :value="content"
    class="template-renderer"
  />
</template>

<script>
import { mapState } from 'vuex'
import DynamicLayoutWrapper from './DynamicLayoutWrapper'

export default {
  components: { DynamicLayoutWrapper },
  props: {
    content: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('settings', ['coursePageTemplate', 'programPageTemplate']),
    pageTemplate() {
      switch (this.type) {
        case 'course':
          return this.coursePageTemplate
        case 'program':
          return this.programPageTemplate
        default:
          throw new Error('Invalid Type')
      }
    },
    questions() {
      return Object.values(this.pageTemplate.questions)
    },
    template() {
      return this.pageTemplate.template
    },
  },
  provide() {
    return {
      questions: this.questions,
    }
  },
}
</script>

<style lang="css" scoped>
.template-renderer >>> a,
.template-renderer >>> .link {
  @apply text-theme-400;
}

.template-renderer >>> a:hover,
.template-renderer >>> .link:hover {
  @apply text-theme-500;
}

.template-renderer >>> a:hover {
  @apply underline;
}
</style>
